import React, { FC, useMemo } from 'react';

import { CloseOutline } from 'ui/components/Icon';

import { getLabelTextDefault } from './helpers';

import { TagPlaceholderProps } from './types';

import { LabelSelected, TagSelected } from './styled';

export const TagPlaceholder: FC<TagPlaceholderProps> = ({
  onClose,
  size,
  count,
  getLabelText = getLabelTextDefault,
}) => {
  const labelText = useMemo(() => getLabelText(count, size), [getLabelText, size, count]);

  return (
    <TagSelected closeIcon={<CloseOutline />} onClose={onClose}>
      <LabelSelected>{labelText}</LabelSelected>
    </TagSelected>
  );
};
